import type { AppOnboard } from "@shared/models/analytics/app"
import type { FindFn } from "@shared/models/analytics/base"
import { createBlankEvent } from "@shared/models/analytics/base"
import type { PreparedAction } from "@shared/actions/action-doc-builder"
import { partial } from "lodash-es"
import type { Narrative } from "@shared/actions/create-narrative"
import createNarrative from "@shared/actions/create-narrative"

interface Payload {}

export default function createClassGoToOrderAction(payload: Payload): PreparedAction {
  return {
    name: "CREATE_CLASS_GO_TO_ORDER",
    payload: payload,
    patches: null,
    undoPatches: null,
    narrative: partial(narrative, payload),
  }
}

function narrative(payload: Payload, _findFn: FindFn, _userId: string): Narrative {
  let newEvent: AppOnboard = {
    ...createBlankEvent(),
    root_id: null,
    root_type: "app",
    date_plan_scheduled_for: null,

    primary_verb: "use",
    primary_possessive: "owns",

    primary_object_type: "app",
    primary_object_id: "commoncurriculum.com",
    primary_object_specifier: "onboarding",
    primary_object_id_and_ancestor_ids: ["commoncurriculum.com"],

    adverbial_verb: "navigating",

    adverbial_object_type: "screen",
    adverbial_object_id: "order",
    adverbial_object_specifier: null,
    adverbial_object_id_and_ancestor_ids: ["commoncurriculum.com"],
  }
  return createNarrative({
    title: "Order Class",
    description: `Creating a class from the Planner`,
    titleForAnalytics: "Create Class - Go To Order",
    newAnalyticsEvents: [newEvent],
  })
}
